import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectOptionType } from '@shared/models/types';

@Component({
  selector: 'app-permissions-grid',
  templateUrl: './permissions-grid.component.html',
  styleUrl: './permissions-grid.component.scss'
})
export class PermissionsGridComponent {
  @Input() form!: FormGroup;
  @Input() availablePermissions: SelectOptionType[] = [];
  @Input() isCurrentUserAdmin = false;
  @Input() isLight = true;
  @Output() permissionSelectionChange = new EventEmitter<{ permissionId: string; checked: boolean }>();

  isPermissionSelected(permissionId: string): boolean {
    const permissions = this.form.get('permissions')?.value || [];
    return permissions.includes(permissionId);
  }

  onPermissionSelection(permissionId: string, checked: boolean): void {
    this.permissionSelectionChange.emit({ permissionId, checked });
  }
}
